import { render, staticRenderFns } from "./rl.vue?vue&type=template&id=71f6b516&scoped=true&"
import script from "./rl.vue?vue&type=script&lang=js&"
export * from "./rl.vue?vue&type=script&lang=js&"
import style0 from "./rl.vue?vue&type=style&index=0&id=71f6b516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6b516",
  null
  
)

export default component.exports